import React, { useState } from 'react';
import { confirmPasswordReset, signInWithEmailAndPassword, verifyPasswordResetCode } from 'firebase/auth';

import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';

function NewPasswordForm({ oobCode }) {
	const [password, setPassword] = useState('');
	const [errorMessage, setErrorMessage] = useState('');
	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			const email = await verifyPasswordResetCode(auth, oobCode);
			await confirmPasswordReset(auth, oobCode, password);
			await signInWithEmailAndPassword(auth, email, password);
			navigate('/');
		} catch (error) {
			handleAuthErrors(error);
		}
	};

	const handleAuthErrors = (error) => {
		const errorMap = {
			'auth/weak-password': 'Password should be at least 6 characters.',
			'auth/expired-action-code': 'This reset link has expired. Please request a new one.',
			'auth/invalid-action-code': 'This reset link is invalid. Please check the link or request a new one.',
			default: 'An error occurred. Please try again.',
		};
		setErrorMessage(errorMap[error.code] || errorMap['default']);
	};

	return (
		<form className="login-form" onSubmit={handleSubmit} noValidate>
			<div className="login-secondary-form">
				<div>
					<h2 className="login-secondary-title">Set a new password</h2>
					<p className="login-secondary-body">Choose a strong password for your account.</p>
				</div>
				<div className="login-field" style={{ marginBottom: 0 }}>
					<label className="login-label" htmlFor="new-password">New password</label>
					<input
						id="new-password"
						className={`login-input${errorMessage ? ' login-input--error' : ''}`}
						type="password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						autoComplete="new-password"
						required
					/>
					{errorMessage && (
						<div className="login-error" style={{ marginTop: 6, marginBottom: 0 }}>{errorMessage}</div>
					)}
				</div>
				<button type="submit" className="login-submit">Set password</button>
			</div>
		</form>
	);
}

export default NewPasswordForm;
